import {
    chakra,
    Box
} from '@chakra-ui/react';

export const Title = chakra(Box, { baseStyle: { boxSizing: 'border-box' } });

export const Header = chakra(Box, {
    baseStyle: {
        bg: 'neutral.50',
        p: '15px 0 15px 0'
    }
});

export const HeaderText = chakra('h1', {
    baseStyle: {
        color: 'neutral.600',
        fontSize: '30px',
        m: '0 15px 0 15px',
        p: '0'
    }
});
